import React from 'react';
import styles from './ExportModal.module.css';
import { copyToClipboard } from '../utils/harUtils';

export default function ExportModal({ requests, activeType, activeScope, searchTerm, fileName, onClose, onToast }) {
  const urls = requests.map(r => r.url).join('\n');

  const typeLabel = activeType === 'all' ? 'All Types' : activeType.toUpperCase();
  const scopeLabel = activeScope === 'all' ? 'All Scopes'
    : activeScope === 'inscope' ? 'In-Scope Only' : 'External Only';

  const handleCopy = () => {
    copyToClipboard(urls).then(() => {
      onToast(`✓ ${requests.length} URLs Copied!`);
      onClose();
    });
  };

  const handleDownload = () => {
    const blob = new Blob([urls], { type: 'text/plain' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    const base = (fileName || 'export').replace(/\.(har|json)$/i, '');
    const suffix = [
      activeType !== 'all' ? `_${activeType}` : '',
      activeScope !== 'all' ? `_${activeScope}` : '',
    ].join('');
    a.download = `${base}${suffix}_urls.txt`;
    a.click();
    URL.revokeObjectURL(a.href);
    onToast(`✓ Downloaded ${requests.length} URLs`);
  };

  return (
    <div className={styles.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.title}>📋 Export URLs</div>
          <button className={styles.closeBtn} onClick={onClose}>✕</button>
        </div>

        <div className={styles.body}>
          <div className={styles.meta}>
            Exporting <strong>{requests.length}</strong> URLs &nbsp;·&nbsp;
            Filter: <strong>{typeLabel}</strong> &nbsp;·&nbsp;
            Scope: <strong>{scopeLabel}</strong>
            {searchTerm && <> &nbsp;·&nbsp; Search: <strong>"{searchTerm}"</strong></>}
          </div>

          <pre className={styles.urlList}>
            {urls || '(no URLs match current filters)'}
          </pre>
        </div>

        <div className={styles.footer}>
          <button className={`${styles.btn} ${styles.btnCopy}`} onClick={handleCopy}>
            📋 Copy All
          </button>
          <button className={`${styles.btn} ${styles.btnDownload}`} onClick={handleDownload}>
            ⬇ Download .txt
          </button>
          <button className={styles.btn} onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
